import { useState, useEffect } from "react";

export default function BuildingStatus({ defaultValue, errors }) {
  const [value, setValue] = useState(defaultValue || "");

  const [isSmall] = useState(window.innerWidth <= 1500);
  const [isSmall1] = useState(window.innerWidth <= 1100);

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  const options = [
    {
      id: "ss1",
      label: isSmall1 ? "ՎԵՐ." : "ՎԵՐԱՆՈՐՈԳՎԱԾ",
      value: "Renovated",
    },
    {
      id: "ss2",
      label: "ԼԱՎ",
      value: "Good-Condition",
    },
    {
      id: "ss3",
      label: isSmall1 ? "ԶՐՈ." : "ԶՐՈՅԱԿԱՆ",
      value: "Zero-Condition",
    },
  ];

  return (
    <div
      className="buildingStatus"
      style={{
        border: errors?.building_status ? "2px solid red" : "none",
        borderRadius: "10px",
      }}
    >
      <h5>
        {isSmall1 ? "ՇԻՆ. ՎԻՃ" : isSmall ? "ՇԻՆ. ՎԻՃԱԿ" : "ՇԻՆՈՒԹՅԱՆ ՎԻՃԱԿ"}
      </h5>

      <div className="with">
        {options.map((option) => (
          <div key={option.id}>
            <input
              type="radio"
              name="building_status"
              id={option.id}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => setValue(e.target.value)}
            />
            <label htmlFor={option.id}>{option.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
}
